export { default as BottomNavbar } from "./bottom-navbar"
export { default as BannerSwipe } from "./banner-swipe"
export { default as Specializations } from "./specializations"
export { default as OurServices } from "./our-services"
export { default as BestLawyers } from "./best-lawyers"
